import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import StoryblokImage from "../../internal/storyblokImage/StoryblokImage";
import "./ImageModal.scss";
import { FormattedMessage, useIntl } from "react-intl";

const ImageModal = (props) => {
  const intl = useIntl();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    //Event handler looks for button click
    document.addEventListener("click", handleButtonClick);
    return () => {
      document.removeEventListener("click", handleButtonClick);
    };
  }, []);

  const handleButtonClick = (event) => {
    var selected = event.target.getAttribute("datapropmodal");
    if (selected == props.blok.modal_id && selected && props.blok.modal_id) {
      handleShow();
    }
  };

  return (
    // <Modal
    //   className="image-modal"
    //   {...props}
    //   size="lg"
    //   aria-labelledby="contained-modal-title-vcenter"
    //   centered
    //   show={show}
    //   onHide={handleClose}
    // >
    //   <Modal.Header>
    //     <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}>{intl.messages["widget.modal.exit"]}</button>
    //   </Modal.Header>
      <Modal.Body><div className="image-wrapper"><StoryblokImage sbImageData={props.blok.image}/></div></Modal.Body>
    // </Modal>
  );
};

export default ImageModal;
